export default __webpack_public_path__ + "static/media/con_trim02.6278cdf3.jpg";